module.exports = __webpack_public_path__ + "static/media/A1.a660ef76.jpg";